export default __webpack_public_path__ + "static/uber.url-2fe302df37c06abd3f3205ec75230923.svg";